import { request} from '@/utils';
import { BaseService } from './base.service';

export type PolicyList = {
  id: string, policyName: string, code: string
}[]

export default class UserService extends BaseService{
  mockPrefixs:string;
  apiPrefix: string;
  cyy: string;
  constructor(globalMock?:boolean){
    super();
    this.mockPrefixs = globalMock ? '/mock': '';
    this.apiPrefix = [this.mockPrefixs, this.userPrefix].join('');
    this.cyy = this.buyerPrefix;
  }

  // 获取默认的隐私协议
  getDefaultPolicy() {
    return request.httpGet<PolicyList>(`${this.homePrefix}/pub/v3/policy/get_all_default_policy?src=WEB`)
  }

  // 获取指定的隐私协议
  getPolicyById(id: string) {
    return request.httpGet<{
      policyName: string;
      policyContent: string;
    }>(`${this.homePrefix}/pub/v3/policy/${id}?src=WEB`);
  }

  // 获取手机验证码 token 图形验证码验证码信息
  getPhoneCode(cellphone: string, token?: string, verifyCodeUseType = 'USER_LOGIN', messageType = 'MOBILE') {
    return request.httpPost<boolean | { authCodeLength: number}>(`${this.apiPrefix}/pub/v5/send_verify_code?src=WEB`,  {
      params: {
        cellphone,
        token,
        verifyCodeUseType,
        messageType,
        src: 'WEB',
      }
    });
  };

  // 获取图形验证码
  getPicCode(cellphone: string,  verifyCodeUseType = 'USER_LOGIN', messageType = 'MOBILE') {
    return request.httpPost<{ baseCode: string }>(`${this.apiPrefix}/pub/v3/generate_photo_code?src=WEB`, {
      params: {
        cellphone,
        verifyCodeUseType,
        messageType,
        src: 'WEB',
      }
    });
  };

  // 登录
  login(cellphone: string, verifyCode: string) {
    return request.httpPost<any>(`${this.apiPrefix}/pub/v3/login_or_register?src=WEB`, {
      params: {
        cellphone,
        verifyCode,
        src: 'WEB',
      }
    });
  };

  // 获取个人信息
  getUserInfo() {
    return request.httpGet<{
      bizCode?: string;
      joinedDay?: string;
      subBizCode?: string;
      userLevel?: string;
      userLevelId?: string;
      userLevelName?: string;
    }>(`${this.apiPrefix}/buyer/v3/profile`);
  }
}
